import breedingCountersDB from "../database/breedingCountersDB";

export function getBreedingCounters(FarmID) {
    return function (dispatch) {
        dispatch({
            type: "GET_BREEDING_COUNTERS",
            payload: breedingCountersDB.getBreedingCounters(FarmID)
        })
    }
}